import React, { useState, useEffect } from 'react';
import { bool } from 'prop-types';

// Import context
import { usePlayerTvContext } from 'components/context/player/player_tv';

// Import components
import { Button, PlayerElements as Player } from 'components/elements';
import Setting from './Setting';
import { Wrapper, Content } from './styles';

// Import utilities
import { usePlayerSettings } from 'components/utilities';

const SettingsController = ({ isCatchupControllers }) => {
	const { resetFocus, isFocus, player } = usePlayerTvContext();
	const [isVisible, setIsVisible] = useState(false);

	const {
		tracks,
		selectedTrack,
		selectedLanguage,
		setSelectedTrack,
		profiles,
		setAudioLanguage
	} = usePlayerSettings(player);

	const handleSetVisible = () => {
		resetFocus();
		setIsVisible((prev) => !prev);
	};

	useEffect(() => {
		!isFocus && setIsVisible(false);
	}, [isFocus]);

	return (
		<Wrapper>
			<Button
				isCatchupControllers={isCatchupControllers}
				onClick={handleSetVisible}
				modifiers={['icon', 'playerIconHover']}
				isFocus={isFocus}
			>
				<Player.IconSettings />
			</Button>
			<Content isVisible={isVisible}>
				<Setting
					profileName="player_settings_profiles"
					data={profiles}
					onSelect={setSelectedTrack}
					selected={selectedTrack}
					minLength={2}
				/>

				<Setting
					profileName="player_settings_language"
					data={tracks}
					onSelect={setAudioLanguage}
					selected={selectedLanguage}
					minLength={2}
				/>
			</Content>
		</Wrapper>
	);
};

SettingsController.propTypes = {
	isCatchupControllers: bool
};

export default SettingsController;
